import { render, staticRenderFns } from "./LensSpendBackDashboard.vue?vue&type=template&id=04294a90&scoped=true"
import script from "./LensSpendBackDashboard.vue?vue&type=script&lang=js"
export * from "./LensSpendBackDashboard.vue?vue&type=script&lang=js"
import style0 from "./LensSpendBackDashboard.vue?vue&type=style&index=0&id=04294a90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04294a90",
  null
  
)

export default component.exports